function setParams(data) {
  const keys = Object.keys(data);
  return keys.reduce((total, key) => {
    return data[key] ? total + `&${key}=${data[key]}` : total;
  }, "");
}

export default setParams;
